//LIBRARIES
import React from 'react';
import { Switch } from 'antd';
import styled from 'styled-components';
import find from 'lodash/find';

//COMPONENTS
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';

//CONSTANTS
import { optionsMapping } from 'constants/options.constants';

//HELPERS
import { colors } from 'helpers/ColorHelper';

//STYLINGS
import 'antd/lib/tree/style/index.css';

const ToggleSwitchSection = styled.div`
  margin-bottom: 4px;
`;

const Title = styled.p`
  font-size: ${(props) => (props.titleSize ? props.titleSize : '14px')};
  font-weight: 400;
  margin: 0px;
  line-height: 40px;
`;

const Description = styled.p`
  line-height: 15px;
`;

const SwitchContainer = styled.div`
  .ant-switch-checked {
    background: ${colors.ULTRAMARINE_BLUE};
  }
  text-align: right;
`;

const ToggleSwitch = ({ name, onChange, isChecked, alertText, titleSize }) => {
  const option = find(optionsMapping, { key: name });

  return (
    <ToggleSwitchSection>
      <Row>
        <Col span={16}>
          <Title titleSize={titleSize}>{option.title}</Title>
        </Col>
        <Col span={3} offset={5}>
          <SwitchContainer>
            <Switch
              size="small"
              onChange={onChange}
              checked={isChecked}
              disabled={option.disabled}
            />
          </SwitchContainer>
        </Col>
      </Row>
      <Description>{`${alertText ? alertText : ''} ${option.description} `}</Description>
    </ToggleSwitchSection>
  );
};

export default ToggleSwitch;
